import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { MEDIA_EDITOR_DOCUMENTATION_URL, SIGN_UP_URL } from '../../../constants/paths';
import { messages } from '../../../i18n';

export const Root = styled.div`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
`;

export const Link = styled.a`
  ${typography.sm.url};
  margin-right: ${globalTheme.spacing.md};
`;

export const HeaderContents: FC = () => (
  <Root>
    <Link href={MEDIA_EDITOR_DOCUMENTATION_URL} target="_blank" rel="noopener noreferrer">
      <FormattedMessage {...messages['header.documentation']} />
    </Link>
    <Link href={SIGN_UP_URL} target="_blank" rel="noopener noreferrer">
      <FormattedMessage {...messages['header.signUp']} />
    </Link>
  </Root>
);
